const Select = {
  EN: {
    label: {
      select: 'SELECT BRAND',
    },
    button: {
      add: 'ADD NEW BRAND',
    },
  },
  TH: {
    label: {
      select: 'เลือกแบรนด์',
    },
    button: {
      add: 'เพิ่มแบรนด์ใหม่',
    },
  },
};

export default Select;
